import { apiErrorName } from '@/lib/apiErrorName';

// User-facing copy of the accept flow. It imports nothing from the API client,
// so the dialog stories can use the real texts without its env validation.

const GATE_FAILURE = {
  title: 'Falta el T&C de canal',
  message:
    'El solicitante aún no aceptó en el hilo. Rechazar sigue disponible.',
};

export function channelTermsLine(terms) {
  if (terms?.alreadyAccepted === true) {
    return 'T&C de canal: el solicitante ya aceptó en el hilo.';
  }
  if (terms?.alreadyAccepted === false) {
    return 'T&C de canal: falta en el hilo.';
  }
  return 'T&C de canal: estado no informado.';
}

// Only these two answers come after the accept committed. A 502 from a gateway
// says nothing about the intake.
export const AFTER_COMMIT_ERRORS = new Set([
  'scraperScrapeFailed',
  'ChannelIntakeOrganizationMissing',
]);

const CASE_ERRORS = {
  tribunalNotInCatalog:
    'El tribunal no existe en el catálogo. Elige otro tribunal.',
  tribunalCourtMismatch: 'El tribunal no pertenece a la corte seleccionada.',
  yearInFuture: 'El año no puede ser futuro.',
  invalidFormInputValue: 'El libro o la competencia no están soportados.',
  ValidationError:
    'Los datos de la causa no son válidos. Revisa los campos e intenta nuevamente.',
};

export function acceptFailure(error) {
  const name = apiErrorName(error?.body);
  if (name === 'ChannelIntakeOrganizationMissing') {
    return {
      title: 'Al pedido le falta su cuenta personal',
      message:
        'El pedido quedó aceptado, pero no tiene una cuenta personal y no se pudo crear la causa.',
    };
  }
  if (name === 'scraperScrapeFailed') {
    return {
      title: 'Falta iniciar la consulta de la causa',
      message: 'No se pudo iniciar la consulta en el Poder Judicial.',
    };
  }
  if (CASE_ERRORS[name]) {
    return {
      title: 'Revisa los datos de la causa',
      message: CASE_ERRORS[name],
    };
  }
  const details = error?.body?.error?.details ?? {};
  if (
    name === 'ChannelTermsAcceptanceRequired' ||
    name === 'ChannelTermsAcceptanceMissing'
  ) {
    return GATE_FAILURE;
  }
  if (name === 'ChannelTermsVersionNotFound') {
    return {
      title: 'No hay términos vigentes',
      message: 'No hay una versión activa. Recarga la cola.',
    };
  }
  if (name === 'ChannelTermsVersionStale') {
    return {
      title: 'Términos desactualizados',
      message:
        'La versión ya no está vigente. Recarga la cola y acepta de nuevo.',
    };
  }
  if (name === 'ChannelIntakeIdentifierInvalid') {
    return {
      title: 'Falta el teléfono',
      message: 'Este hilo no tiene un E.164. Pídelo en Kapso; no lo inventes.',
    };
  }
  if (name === 'ChannelIdentityCollision') {
    // The API returns only the caller's identifier, never the other org's data.
    const number = details.identifier
      ? `El WhatsApp ${details.identifier}`
      : 'Este WhatsApp';
    return {
      title: 'Identidad en otra org',
      message: `${number} ya pertenece a otra organización. No fusionar.`,
    };
  }
  // A 5xx message comes from the server or the gateway, in English.
  if (error?.status >= 500) {
    return {
      title: 'Sin respuesta del servidor',
      message: 'No se pudo confirmar el resultado.',
    };
  }
  return {
    title: 'No se pudo aceptar',
    message: error?.message ?? 'Error desconocido.',
  };
}

// The terms lookup runs before any accept is sent, so a 5xx there says nothing
// about the pedido.
export function termsLookupFailure(error) {
  if (error?.status >= 500) {
    return {
      title: 'No se pudo consultar el T&C',
      message: 'No se pudo consultar el T&C de canal. Intenta de nuevo.',
    };
  }
  return acceptFailure(error);
}
